import _objectWithoutProperties from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties"; // @ts-check

import React from 'react';
import InsertPieChartDialog from './InsertPieChartDialog';
import InsertGaugeDialog from './InsertGaugeDialog';
import InsertSeriesChartDialog from './InsertSeriesChartDialog';
import InsertTableDialog from './InsertTableDialog';

var InsertDialog = function InsertDialog(_ref) {
  var type = _ref.type,
      rest = _objectWithoutProperties(_ref, ["type"]);

  switch (type) {
    case 'pieChart':
      return React.createElement(InsertPieChartDialog, rest);

    case 'columnChart':
    case 'barChart':
    case 'lineChart':
    case 'areaChart':
      return React.createElement(InsertSeriesChartDialog, Object.assign({
        type: type
      }, rest));

    case 'table':
      return React.createElement(InsertTableDialog, rest);

    case 'gauge':
    case 'circularGauge':
      return React.createElement(InsertGaugeDialog, rest);

    default:
      throw new Error('Invalid type');
  }
};

export default InsertDialog;